import { ReactNode, useState } from "react";
import { Link } from "react-router-dom";

import { Layout } from "antd";

import {
  StyledBrand,
  StyledBrandName,
  StyledBrandTag,
  StyledContent,
  StyledContentInner,
  StyledLayout,
  StyledLayoutSider,
} from "@app/components/layout/StyledLayout.tsx";
import { CmtMenu } from "@app/components/menu/CmtMenu.tsx";

interface LayoutProps {
  children: ReactNode;
}

export const CmtLayout = ({ children }: LayoutProps) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <StyledLayout>
      <StyledLayoutSider
        width={240}
        breakpoint="lg"
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
      >
        <StyledBrand as={Link} to="/">
          <StyledBrandName>{collapsed ? "t" : "takima"}</StyledBrandName>
          {!collapsed && <StyledBrandTag>App-User</StyledBrandTag>}
        </StyledBrand>
        <CmtMenu />
      </StyledLayoutSider>
      <Layout>
        <StyledContent>
          <StyledContentInner>{children}</StyledContentInner>
        </StyledContent>
      </Layout>
    </StyledLayout>
  );
};
